import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionHistoryState } from '../reducers/transaction-history.reducer';

const featureState = createFeatureSelector<TransactionHistoryState>('transactionsHistory');

export const selectTransactionsLoading = createSelector(
  featureState,
  (state) => state.transactionsLoading,
);
export const selectTransactionsFilter = createSelector(
  featureState,
  (state) => state.transactionsFilter,
);
export const selectTransactions = createSelector(featureState, (state) => ({
  items: state.transactions,
  totalCount: state.totalTransactions,
}));
export const selectTransactionsInsights = createSelector(featureState, (state) => ({
  successRate: state.successRate,
  totalThisMonth: state.totalThisMonth,
  totalThisWeek: state.totalThisWeek,
  totalToday: state.totalToday,
  totalTransactions: state.totalTransactions,
  totalFailedTransactions: state.totalFailedTransactions,
  monthOverMonthChange: state.monthOverMonthChange,
}));
